import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from './store/app/hooks';

interface RouteAuthProps {
	element: React.ReactElement;
	requiredFeatures: string[];
}

const RouteAuth: React.FC<RouteAuthProps> = ({ element, requiredFeatures }) => {
	const userAuthorizationValueStore = useAppSelector(state => state.users.userRoleFeatures);

	if (!userAuthorizationValueStore) {
		return (<Navigate to="/" replace />);
	}

	const userPermissions: string[] = userAuthorizationValueStore || [];
	const hasRequiredFeatures = requiredFeatures.some((feature) => userPermissions.includes(feature.toLowerCase()));

	if (hasRequiredFeatures) {
		return element;
	} else {
		return <Navigate to="/" replace />;
	}
};

export default RouteAuth;